import React from 'react';
import { OriSelect } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
import { posterType } from 'src/tools/contentModulesFieldName';
//import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import { i18nGet } from 'src/tools/tools';

const Option = OriSelect.Option;

const PosterType = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled, options, onTypeChange } = props;

  return (
    <Section {...sectionProps}>
      <ItemWrapper title={getI18n('general.posterType')}>
        <Field name={posterType}>
          {(props, m) => {
            const { value, onChange } = props;
            return (
              <OriSelect
                disabled={disabled}
                size='large'
                onChange={(e) => {
                  onChange(e);
                  onTypeChange(e);
                }}
                value={value}
                //   onChange={handleOnModuleWidthChange}
              >
                {options.map((i) => {
                  const { label, value } = i;
                  return (
                    <Option value={value} key={value}>
                      {label}
                    </Option>
                  );
                })}
              </OriSelect>
            );
          }}
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default PosterType;
